export default {"src":"/_next/static/media/logo_white_horizontal.3835655b.svg","height":22,"width":141};